import { z as zod } from 'zod';
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { Enum_Teammember_Gender } from "@/app/lib/generated/graphql-types";
import { PhoneSchema } from "@/app/features/shared/__to_be_integrated/types/forms/PhoneSchema";

export const TeamMemberSchema = zod.object({
    documentId: zod.string(),
    title: zod.string(),
    firstName: zod.string().min(1, { message: "Pflichtfeld" }),
    lastName: zod.string().min(1, { message: "Pflichtfeld" }),
    description: zod.string().optional(),
    phones: zod.array(PhoneSchema),
    email: zod.string().email(),
    image: MediaRefSchema.nullish(),
    gender: zod.nativeEnum(Enum_Teammember_Gender),
    order: zod.number().nullish()
})

export type TeamMemberEditable = zod.infer<typeof TeamMemberSchema>;
export type PhoneEditable = zod.infer<typeof PhoneSchema>;